import { Card, Space } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';
import cn from 'classnames';

import styles from './ParamsTable.module.scss';

interface IParamsTableProps {
  data: Array<{
    title: string;
    items: string[];
  }>;
}

export const ParamsTable = ({ data }: IParamsTableProps) => (
  <Space
    direction="vertical"
    size={8}
  >
    {data.map(({ title, items }, index) => (
      <Card
        key={title}
        color={index % 2 === 0 ? 'dark' : 'light'}
      >
        <Space>
          <Text
            className={cn(styles.col1, 'h-color-D60')}
            size={14}
          >
            {title}
          </Text>
          <Space
            className={styles.col2}
            direction="vertical"
            size={8}
          >
            {items.map((item) => (
              <Text
                key={item}
                size={14}
              >
                {item}
              </Text>
            ))}
          </Space>
        </Space>
      </Card>
    ))}
  </Space>
);
